$(document).ready(function () {
    const $checkbox = $('.checkbox-cart');
    const $button = $('#checkout');
    const $name = $('#cartform-name');
    const $email = $('#cartform-email');
  const $sign = $('#cartform-sign');
    if (!sessionStorage.getItem('checkboxChecked')) {
        $checkbox.prop('checked', false); // Uncheck the checkbox on page load
        $button.prop('disabled', true); // Disable the button
    }
    const isFormValid = function () {
        const isCheckboxChecked = $checkbox.prop('checked');
        const isNameFilled = $name.val().trim() !== "";
        const isEmailFilled = $email.val().trim() !== "" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($email.val());
      const isSignFilled = $sign.val().trim() !== "";
        return isCheckboxChecked && isNameFilled && isEmailFilled && isSignFilled;
    };
    const updateButtonState = function () {
        $button.prop('disabled', !isFormValid()); // Enable the button only if the form is valid
    };
    $checkbox.on('change', updateButtonState);
    $name.on('input', updateButtonState);
    $email.on('input', updateButtonState);
    $sign.on('input', updateButtonState);
});
 // document.getElementById('checkout').addEventListener('click', function (e) {
 //    e.preventDefault(); 
 //    const name = document.getElementById('cartform-name').value.trim();
 //    const email = document.getElementById('cartform-email').value.trim();
 //    const signature = document.getElementById('cartform-sign').value.trim();
 //    const termsChecked = document.getElementById('blankCheckbox').checked;
 //    if (!name || !email || !signature || !termsChecked) {
 //      alert("Please fill in all required fields and agree to the terms.");
 //      return;
 //    }
 //    const form = document.getElementById('ContactForm');
 //    const formData = new FormData(form);
 //    fetch(form.action, {
 //      method: form.method,
 //      body: formData,
 //    })
 //      .then((response) => {
 //        if (response.ok) {
 //          window.location.href = '/checkout';
 //        } else {
 //          alert("Form submission failed. Please try again.");
 //        }
 //      })
 //      .catch((error) => {
 //        console.error("Form submission error:", error);
 //        alert("An error occurred. Please try again.");
 //      });
 //  });
const checkoutButton = document.querySelector('.popup-button-checkout');
const termPopup = document.querySelector('.term-condition-popup');
const closeButton = document.querySelector('.close-btn');
checkoutButton.addEventListener('click', function() {
    termPopup.style.display = 'flex';
});
closeButton.addEventListener('click', function() {
    termPopup.style.display = 'none';
});
window.addEventListener('click', function(event) {
    if (event.target === termPopup) {
        termPopup.style.display = 'none';
    }
});
const termsCheckbox = document.getElementById('termsCheckbox');
const digitalSignature = document.getElementById('digitalSignature');
const submitButton = document.getElementById('submitButton');
const validateForm = () => {
    if (termsCheckbox.checked && digitalSignature.value.trim() !== "") {
        submitButton.disabled = false;
    } else {
        submitButton.disabled = true;
    }
};
termsCheckbox.addEventListener('change', validateForm);
digitalSignature.addEventListener('input', validateForm);
const closePopup = () => {
    alert("Popup closed!");
};
submitButton.addEventListener('click', () => {
    const signature = digitalSignature.value.trim();
    if (signature) {
        localStorage.setItem('digitalSignature', signature);
        alert(`Thank you! Your agreement has been recorded as: ${signature}`);
    }
});
document.addEventListener('click', function (e) {
  if (e.target.closest('.product-choose-option')) {
    const option = e.target.closest('.product-choose-option');
    document.querySelectorAll('.product-choose-option .right-icon').forEach(icon => {
      icon.style.display = 'none';
    });
    const icon = option.querySelector('.right-icon');
    if (icon) {
      icon.style.display = 'block';
    }
  }
});